<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Processando...</p>
  </ngx-spinner>
  <section class="d-flex flex-column p-4">
    <div class="mb-3">
      <h3>Validar Extrato Processamento EFD</h3>
    </div>

    <div class="d-flex flex-column py-1 px-3">

      <div class="d-flex gap-4">
        <mat-form-field appearance="fill" class="w-50">
          <mat-label style="font-size: 14px">Informe o Número do Extrato</mat-label>
          <input
            matInput
            [formControl]="numeroExtratoControl"
            id="numeroExtrato"
            name="numeroExtrato"
            autocomplete="off"
            required
          />
        </mat-form-field>
      </div>

      <div class="d-flex gap-4 mt-3">
        <sfz-button title="Limpar" startIcon="trash" (click)="limpar()" size="md"></sfz-button>
        <sfz-button title="Validar Extrato" startIcon="patch-check" [disabled]="!numeroExtratoPreenchido" (click)="consultar()" size="md"></sfz-button>
      </div>

    </div>
  </section>
